"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopProductSelection = void 0;
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var shop_product_1 = require("../enums/shop-product");
var ShopProduct_1 = require("./ShopProduct");
var ShopProductSelection = /** @class */ (function (_super) {
    __extends(ShopProductSelection, _super);
    function ShopProductSelection(collection, product) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var products = (0, hydrogen_react_1.flattenConnection)(collection.products);
        _this = _super.call(this, products, product) || this;
        _this.options = [];
        _this.upsells = [];
        _this.upsellBundles = []; // S587 - A/B: section 4 bundle upsell
        _this.modifier = {}; // use this for modifying the shop section
        // convert metafield array to object for easier access
        var metafields = collection.metafields.reduce(function (acc, curr) {
            var _a;
            if (curr) {
                return __assign(__assign({}, acc), (_a = {}, _a[curr.key] = curr, _a));
            }
            return acc;
        }, {});
        // assign upsell list
        var upsellRefs = (_a = metafields['shop_upsell_list']) === null || _a === void 0 ? void 0 : _a.references;
        if (upsellRefs) {
            _this.upsells = (0, hydrogen_react_1.flattenConnection)(upsellRefs);
        }
        // Assign brand
        _this.brand = ((_b = metafields['shop_brand']) === null || _b === void 0 ? void 0 : _b.value) || _this.brand;
        // Assign options
        var optionStr = (_c = metafields['shop_option']) === null || _c === void 0 ? void 0 : _c.value;
        var optionJson = optionStr ? JSON.parse(optionStr) : null;
        var options = [];
        if (Array.isArray(optionJson)) {
            options = optionJson.map(function (opt) { return '' + opt; });
        }
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var opt = options_1[_i];
            var list = opt.split('|');
            if (ShopProduct_1.ShopProduct.isEnum(list[0], shop_product_1.OptionKey)) {
                _this.options.push({
                    option: list[0],
                    main: list[1],
                    sub: list[2],
                });
            }
        }
        // TODO validate options
        // Assign get now value
        var getNowMetafield = (_d = metafields['shop_get_now']) === null || _d === void 0 ? void 0 : _d.value;
        _this.getNowText = getNowMetafield || 'GET ' + _this.brand.split('-')[0] + ' NOW';
        _this.unit = ((_e = metafields['shop_unit']) === null || _e === void 0 ? void 0 : _e.value) || 'bottle';
        // Assign modifier from metaobject
        if ((_f = metafields['shop_modifier']) === null || _f === void 0 ? void 0 : _f.reference) {
            _this.modifier = metafields['shop_modifier'].reference.fields.reduce(function (acc, curr) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[curr.key] = curr, _a)));
            }, {});
        }
        return _this;
    }
    ShopProductSelection.prototype.getOneTimeProduct = function (quantity) {
        var product = this.products.find(function (product) {
            var metafields = product.metafields;
            var includes = metafields[0], type = metafields[1];
            return (includes === null || includes === void 0 ? void 0 : includes.value.includes("=".concat(quantity))) && (type === null || type === void 0 ? void 0 : type.value) === shop_product_1.TypeKey.oneTime;
        });
        if (!product) {
            console.error('Error - undefined value in getSubscriptionProduct');
            return;
        }
        var arrayLength = product.variants.nodes.length;
        return product === null || product === void 0 ? void 0 : product.variants.nodes[arrayLength - 1];
    };
    ShopProductSelection.prototype.getSubscriptionProduct = function (quantity) {
        var product = this.products.find(function (product) {
            var metafields = product.metafields;
            var includes = metafields[0], type = metafields[1];
            return (includes === null || includes === void 0 ? void 0 : includes.value.includes("=".concat(quantity))) && (type === null || type === void 0 ? void 0 : type.value) === shop_product_1.TypeKey.subscription;
        });
        if (!product) {
            console.error('Error - undefined value in getSubscriptionProduct');
            return;
        }
        return product;
    };
    // retrieves a subscription variant of a chosen product.
    ShopProductSelection.prototype.getSubscriptionProductVariant = function (quantity) {
        var productVariant = this.getSubscriptionProduct(quantity);
        if (!productVariant) {
            console.error('Error - getSubscriptionProduct returned undefined');
            return;
        }
        var arrayLength = productVariant === null || productVariant === void 0 ? void 0 : productVariant.variants.nodes.length;
        return productVariant === null || productVariant === void 0 ? void 0 : productVariant.variants.nodes[arrayLength - 1];
    };
    ShopProductSelection.prototype.getOneQuantityProductVariant = function (productType) {
        var product = this.products.find(function (product) {
            var metafields = product.metafields;
            var includes = metafields[0], type = metafields[1];
            return (includes === null || includes === void 0 ? void 0 : includes.value.includes('=1')) && (type === null || type === void 0 ? void 0 : type.value) === productType;
        });
        var productVariant = product === null || product === void 0 ? void 0 : product.variants.nodes[0];
        return productVariant;
    };
    ShopProductSelection.prototype.getOptions = function () {
        return this.options;
    };
    ShopProductSelection.prototype.shouldShowOptions = function () {
        return this.options.length >= 2;
    };
    ShopProductSelection.prototype.getTypes = function (selection) {
        return Object.keys(this.shopProductMap[selection.option]);
    };
    ShopProductSelection.prototype.shouldShowTypes = function (selection) {
        return this.getTypes(selection).length >= 2;
    };
    ShopProductSelection.prototype.getQuantities = function (selection) {
        return Object.keys(this.shopProductMap[selection.option][selection.type]).map(function (elem) { return +elem; });
    };
    ShopProductSelection.prototype.shouldShowQuantities = function (selection) {
        return this.getQuantities(selection).length >= 3;
    };
    ShopProductSelection.prototype.getUpsells = function () {
        return this.upsells;
    };
    // S587 - A/B: section 4 bundle upsell
    ShopProductSelection.prototype.getBundleUpsells = function () {
        return this.upsellBundles;
    };
    ShopProductSelection.prototype.shouldShowUpsells = function () {
        return this.upsells[0] !== undefined;
    };
    ShopProductSelection.prototype.getUnit = function () {
        return this.unit;
    };
    ShopProductSelection.prototype.getGetNowText = function () {
        return this.getNowText;
    };
    ShopProductSelection.prototype.getModifier = function () {
        return this.modifier;
    };
    return ShopProductSelection;
}(ShopProduct_1.ShopProduct));
exports.ShopProductSelection = ShopProductSelection;
